import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex no-wrap justify-between" }

import { QCheckbox } from "quasar"
import { PriorityClass } from "src/util/types/misc"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxPriorityFilter',
  props: /*#__PURE__*/_mergeModels({
  /** Exclude input elements for these priority classes */
  hide: { type: Array as PropType<PriorityClass[]> },
  /** Show large checkboxes. */
  large: { type: Boolean },
}, {
    "modelValue": { required: true, type: Array as PropType<PriorityClass[]> },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel(__props, "modelValue")
const props = __props
//endregion

//region Variables

// Compute the included priority classes via set difference with all classes.
const all: Array<PriorityClass> = ["priority1", "priority2", "priority3", "priority4", "priority5"]
const included = computed(() => all.filter((priority) => !(props.hide ?? []).includes(priority)))

// We want small to be 24x24 px and large to be 32x32.
// Due to border widths we need to compute the size to pass to quasar.
const size = computed(() => (props.large ? 32 : 24) * 2 - 8)
//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(included.value, (priority) => {
      return (_openBlock(), _createBlock(_unref(QCheckbox), {
        class: _normalizeClass(`sfx-priority-filter bg-${priority}`),
        key: priority,
        dense: "",
        color: "transparent",
        "keep-color": "",
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        val: priority,
        size: `${size.value}px`
      }, null, 8, ["class", "modelValue", "val", "size"]))
    }), 128))
  ]))
}
}

})